export const MEASUREMENT_SYSTEMS = {
  metric: 'metric',
  usc: 'usc',
};

export type MeasurementSystem =
  (typeof MEASUREMENT_SYSTEMS)[keyof typeof MEASUREMENT_SYSTEMS];

// ------------------------------------
// Distance

export const DISTANCE_UNITS = {
  [MEASUREMENT_SYSTEMS.metric]: {
    m: 'meters',
    km: 'kilometers',
  },
  [MEASUREMENT_SYSTEMS.usc]: {
    ft: 'feet',
    mi: 'miles',
    nmi: 'nauticalmiles',
  },
} as const;

export type MetricDistanceUnit =
  (typeof DISTANCE_UNITS.metric)[keyof typeof DISTANCE_UNITS.metric];

export type USCDistanceUnit =
  (typeof DISTANCE_UNITS.usc)[keyof typeof DISTANCE_UNITS.usc];

export type DistanceUnit = MetricDistanceUnit | USCDistanceUnit;

// ------------------------------------
// Area

export const AREA_UNITS = {
  [MEASUREMENT_SYSTEMS.metric]: {
    ha: 'hectares',
    km2: 'square-kilometers',
    m2: 'square-meters',
  },
  [MEASUREMENT_SYSTEMS.usc]: {
    ac: 'acres',
    ft2: 'square-feet',
    mi2: 'square-miles',
    nmi2: 'square-nauticalmiles',
  },
} as const;

export type MetricAreaUnit =
  (typeof AREA_UNITS.metric)[keyof typeof AREA_UNITS.metric];

export type USCAreaUnit = (typeof AREA_UNITS.usc)[keyof typeof AREA_UNITS.usc];

export type AreaUnit = MetricAreaUnit | USCAreaUnit;

// ------------------------------------
// Symbols

export const UNIT_SYMBOLS: {[key: string]: string} = {
  [AREA_UNITS.metric.ha as string]: 'ha',
  [AREA_UNITS.metric.km2 as string]: 'km²',
  [AREA_UNITS.metric.m2 as string]: 'm²',
  [AREA_UNITS.usc.ac as string]: 'ac',
  [AREA_UNITS.usc.ft2 as string]: 'ft²',
  [AREA_UNITS.usc.mi2 as string]: 'mi²',
  [AREA_UNITS.usc.nmi2 as string]: 'nmi²',
  [DISTANCE_UNITS.metric.km as string]: 'km',
  [DISTANCE_UNITS.metric.m as string]: 'm',
  [DISTANCE_UNITS.usc.ft as string]: 'ft',
  [DISTANCE_UNITS.usc.mi as string]: 'mi',
  [DISTANCE_UNITS.usc.nmi as string]: 'nmi',
} as const;
